<template>
  <div class="usage_block">
    <h2 class="large_black_label">便利な活用法</h2>
    <h3 class="client_label">クライアントとして</h3>
    <div>
      <div class="left">
        <img class='base_image' src='@/assets/image/pages/top/client1.jpg'>
      </div>
      <div class="right">
        <h3 class="client_label">突発的に生じた図面修正にすぐ対応。</h3>
        <p>設計変更や仕様変更が予期せず生じることも多々あるかと思います。</p>
        <p>でもすでに自分は新しいプロジェクトに取り掛かっていて時間が取れなかったり、今まで頼んでいたオペレーターとの契約が切れており頼む人がいない、</p>
        <p>ちょっとした作業で契約・決済するのは面倒…。</p>
        <p>そういった経験はないでしょうか？</p>
        <br>
        <p>フルーはクライアントが指定した条件に合致するオペレーターの中から、<span class="strong_label">すぐに作業にかかれる方</span>を自動で探し出して紹介します。</p>
        <p>また、<span class="strong_label">決済機能も備えている</span>ので、後からオペレーターの銀行口座に振り込む手間を省けるため、<span class="strong_label">少額発注を手軽に行えます。</span></p>
      </div>
    </div>
    <div>
      <div class="left">
        <img class='base_image' src='@/assets/image/pages/top/client2.jpg'>
      </div>
      <div class="right">
        <h3 class="client_label">単純な反復作業や<br>既存図面のCAD起こしを頼みたい時に。</h3>
        <p>基準階の階高や基準スパンの長さ変更で同じ作業を繰り返さなければいけない時や、既存図面のCAD起こしをしなければいけない時、さっと誰かに頼んで自分はもっと難しい作業やクリエイティブなデザイン検討などに時間を使いたいと思うことはありませんか？</p>
        <br>
        <p>フルーはちょっとした作業をすぐに頼める、<span class="strong_label">“四六時中あなたに寄り添う助手”</span>のような存在になりたいと考えています。</p>
        <p>それにより、設計業務がもっとクリエイティブで効率的なものになれば幸いです。</p>
      </div>
    </div>

    <h3 class="operator_label">オペレーターとして</h3>
    <div>
      <div class="left">
        <img class='base_image' src='@/assets/image/pages/top/operator1.jpg'>
      </div>
      <div class="right">
        <h3 class="operator_label">予定業務が延期になって<br>時間が空いたその日だけ。</h3>
        <p>作図業務を受託し、発注者から作図指示資料を受領するはずの日、発注者から電話がかかってきて「すみませんが、3日遅れます…」と延期の連絡が入り、3日間時間を持て余してしまう。</p>
        <p>似たような経験をされた方は多いのではないでしょうか？</p>
        <p>フルーが取り扱う作業は<span class="strong_label">短時間・単発の作業</span>であるため、このような状況下で空き時間を有効に使える業務を受注するチャンスがあります。</p>
        <br>
        <p>また、設計事務所の中で管理職の立場にある方にとっては、短期的に配下の社員に指示する作業が無く、待機状態にさせてしまうこともあるかと思います。</p>
        <p>このような時、フルーで<span class="strong_label">従業員アカウント</span>を利用して業務を受注できれば、<span class="strong_label">余剰労働力の有効活用と事務所収入の増加</span>が見込めます。</p>
      </div>
    </div>
    <div>
      <div class="left">
        <img class='base_image' src='@/assets/image/pages/top/operator2.jpg'>
      </div>
      <div class="right">
        <h3 class="operator_label">家事・育児の合間や休日の副業に。</h3>
        <p>設計事務所に所属しているが現在育児休業中の方や、休日にちょっとだけ副業として<span class="strong_label">自分の職能を活かして</span>自宅で仕事をしたい方もいらっしゃるかと思います。</p>
        <br>
        <p>フルーで業務を受注する場合、あなたがやることは<span class="strong_label">空き時間を登録してマッチング通知を待つだけ。</span></p>
        <p>受注のために仕事をあれこれ探して応募して結果を待つ必要はありません。</p>
        <p>ましてや応募して指名されなければ全ての苦労が無駄になってしまいます。</p>
        <p>フルーはあなたの貴重な時間を無駄にしません。</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "UsageBlock",
  }
</script>

<style lang="scss" scoped>
  .usage_block {
    > h2, > h3, > div  {
      margin-bottom: 4rem;
    }
    > div {
      @include double_columns(30%, 50%);
    }
  }
</style>